import React, { useEffect } from "react";
import ResponsivePagination from "react-responsive-pagination";
import { useNavigate } from "react-router-dom";
import "react-responsive-pagination/themes/classic.css";
import { useDispatch, useSelector } from "react-redux";
import {
  updateCurrentPage,
  updateLoading,
} from "../../redux/slices/paginationSlice";
import Loader from "components/Loader/Loader";
import { useSearchParams, useLocation } from "react-router-dom";
import { HStack, Text } from "rsuite";

export default function Pagination() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  const { loading, totalItems, totalPages } = useSelector(
    (state) => state.pagination
  );

  const currentPage = Number(searchParams.get("page")) || 1;

  const pageFromUrl = Number(searchParams.get("page")) || 1;

  useEffect(() => {
    // setTimeout(() => {
    dispatch(updateCurrentPage(pageFromUrl));
    // }, 1000);
  }, [pageFromUrl, dispatch]);

  const handlePageChange = (page) => {
    const query = new URLSearchParams(location.search);
    if (query.has("page")) {
      query.set("page", page);
    } else {
      query.append("page", page);
    }
    navigate({ search: query.toString() });
    dispatch(updateLoading(true));
    dispatch(updateCurrentPage(page));
  };

  return (
    <>
      <HStack
        {...(totalItems
          ? { justifyContent: "space-between" }
          : { justifyContent: "center" })}
        className="my-15"
      >
        {totalItems ? (
          <Text>
            Total Records: <strong>{totalItems}</strong>
          </Text>
        ) : null}
        {totalPages ? (
          <div>
            <ResponsivePagination
              current={currentPage}
              total={totalPages}
              onPageChange={(page) => {
                handlePageChange(page);
              }}
              maxWidth={380}
            />
          </div>
        ) : null}
      </HStack>
      {loading && <Loader />}
    </>
  );
}
